import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import { TooltipStandard } from "./TooltipStandard";

export const TooltipInfoHover = ({
  icon = (
    <BsInfoCircle
      className="info-circle-color"
      style={{ marginTop: "-.2rem" }}
    />
  ),
  placement = "top",
  iconStyleMerge,
  children,
  tooltipClass,
  ...props
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      flip
      overlay={
        <TooltipStandard id={`tooltip-top`} className={tooltipClass}>
          {children}
        </TooltipStandard>
      }
      {...props}
    >
      <div style={{ display: "inline", ...iconStyleMerge }}>{icon}</div>
    </OverlayTrigger>
  );
};
